/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-img-element */

import EmbeddedYoutube from 'containers/CollectionPage/views/EmbeddedYoutube';

const CatalogSection = () => {
  const catalog = [
    {
      label: 'Zoom Virtual Meetings',
      iconUrl:
        'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/virtual-meeting.png',
      videoId: 'pAMDxH_H_Cs',
      desc: '<p class="text-sm text-justify">Zoom Virtual Meetings adalah solusi komunikasi online dengan video berkualitas tinggi untuk rapat, webinar, dan pembelajaran. Fitur unggulannya meliputi <span class="font-bold italic">Smart Recording</span> untuk merekam poin penting, <span class="font-bold italic">In Meeting Question</span> untuk tanya jawab selama rapat, dan <span class="font-bold italic">Meeting Summary</span> yang otomatis merangkum hasil rapat.</p>',
    },
    {
      label: 'Zoom Team Chat',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/team-chat.png',
      videoId: 'ChRSB5Ixrts',
      desc: '<p class="text-sm text-justify">Zoom Team Chat mendukung komunikasi <span class="italic">real-time</span> untuk kolaborasi tim. Keunggulannya meliputi <span class="font-bold italic">Chat Compose</span> untuk menyusun pesan lebih cepat dan rapi, <span class="font-bold italic">Thread Summary</span> yang merangkum percakapan secara otomatis, <span class="font-bold italic">Quick Schedule</span> untuk menjadwalkan rapat langsung dari chat, serta <span class="font-bold italic">Sentence Completion</span> berbasis AI untuk menyusun pesan profesional.</p>',
    },
    {
      label: 'Zoom Phone',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/phone.png',
      videoId: 'xZfCxpVwT6A',
      desc: '<p class="text-sm text-justify">Layanan telepon berbasis <span class="italic">cloud</span> yang memungkinkan panggilan suara dua arah dan fungsi <span class="italic">private branch exchange</span> (PBX). Terdapat <span class="font-bold italic">Call Summary</span> yang memberikan ringkasan <span class="font-bold italic">history</span> telepon yang telah selesai, ini membantu pengguna untuk mengetahui <span class="italic">detail</span> penting dari percakapan telepon. Fitur <span class="font-bold italic">Voicemail</span>  memungkinkan pengguna untuk membuat atau menerima pesan suara.</p>',
    },
    {
      label: 'Zoom Event',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/calendar.png',
      videoId: '0zm3rP7iQ0w',
      desc: '<p class="text-sm text-justify">Zoom Events memungkinkan pengguna untuk mengadakan acara virtual atau hybrid yang dapat diselenggarakan dalam beberapa sesi dan hari. Beberapa fitur dari Zoom Event antara lain; pendaftaran dan pembelian tiket, email dan branding yang dapat disesuaikan sesuai kebutuhan acara, ruang pameran virtual yang dapat dimanfaatkan oleh sponsor atau pengunjung event.</p>',
    },
    {
      label: 'Zoom Mail & Calendar',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/mail.png',
      videoId: 'Dxmst-0UQV0',
      desc: '<p class="text-sm text-justify">Fitur Zoom Mail dan Calendar dapat terintegrasi ke email yang sudah dimiliki. Fitur ini memberikan kemudahan bagi pengguna untuk mengakses email, mengirim, menerima pesan tanpa perlu keluar dari platform Zoom. Terdapat <span class="font-bold italic">Email Compose</span> fitur yang memungkinkan pengguna untuk membuat email baru atau menanggapi email dengan bantuan AI Companion.</p>',
    },
    {
      label: 'Zoom Contact Center',
      iconUrl:
        'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/contact-center.png',
      videoId: 'mYug2f8nrlM',
      desc: '<p class="text-sm text-justify">Layanan Zoom Contact Center adalah perangkat lunak berbasis cloud untuk pusat kontak yang memungkinkan organisasi mengelola interaksi dengan pelanggan atau pengguna akhir mereka melalui beberapa saluran, termasuk suara dan video. Layanan ini ideal untuk organisasi yang ingin meningkatkan kualitas layanan pelanggan dengan alat komunikasi modern dan fleksibel.</p>',
    },
    {
      label: 'Zoom Docs',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/docs.png',
      videoId: '-HhuKL1Q40E',
      desc: '<p class="text-sm text-justify">Zoom Docs menggabungkan pengolahan dokumen dengan teknologi <span class="font-bold">AI Companion.</span> Fitur ini terhubung langsung dengan Zoom Meetings dan dapat mengubah informasi rapat menjadi dokumen, wiki, atau daftar tugas. Zoom Docs dirancang untuk membantu merapikan dokumen agar lebih terstruktur guna membantu tim tetap produktif dan efisien.</p>',
    },
    {
      label: 'Zoom Room',
      iconUrl:
        'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/group-discussion.png',
      videoId: 'MctTZR4gIXo',
      desc: '<p class="text-sm text-justify">Zoom Rooms menghadirkan kolaborasi video HD yang dapat diakses di mana saja baik secara langsung maupun jarak jauh  secara real-time. Mudah untuk memulai rapat, pesan ruangan, dan berbagi konten. Zoom Rooms memiliki fitur khusus ruang konferensi seperti <span class="font-bold">Scheduling Display, Digital Signage,</span> dan beberapa ruangan seperti <span class="font-bold">Personal Zoom Rooms, Classrooms, Boardrooms.</span></p>',
    },
    {
      label: 'Zoom Whiteboard',
      iconUrl: 'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/whiteboard.png',
      videoId: 'idEfUlb4rRs',
      desc: '<p class="text-sm text-justify">Zoom Whiteboard adalah fitur yang memungkinkan pengguna membuat papan tulis digital sehingga dapat membuat catatan, menggambar, memberi komentar dan membuat jenis anotasi lainnya. Zoom Whiteboards memiliki fitur untuk mempermudah kolaborasi bersama tim yang dapat diakses di mana saja melalui perangkat desktop, browser web, atau Zoom Room for Touch.</p>',
    },
    {
      label: 'Zoom Workspace Reservation',
      iconUrl:
        'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/gesture-click.png',
      videoId: '96aE3teiVOY',
      desc: '<p class="text-sm text-justify">Zoom Workspace Reservation memungkinkan pengguna memesan ruang kerja melalui Zoom untuk mendukung model kerja fleksibel. Fitur ini mencakup memesan ruang kerja sebelumnya, saat kedatangan atau langsung di ruang kerja; memberikan rekomendasi tentang ruang kerja yang dapat dipesan; menyusun dan melihat peta lantai; serta menganalisis data terkait penggunaan ruang kerja.</p>',
    },
    {
      label: 'Zoom Revenue Accelerator',
      iconUrl:
        'https://storage.googleapis.com/xooply-assets/cp/zoom/catalog/icons/speed-rounded.png',
      videoId: 'n_x_gbCkvZI',
      desc: '<p class="text-sm text-justify">Zoom Revenue Accelerator adalah solusi berbasis AI yang dirancang untuk membantu tim penjualan dan pemasaran meningkatkan efisiensi, produktivitas, dan hasil bisnis. Fitur ini dapat menganalisis percakapan pelanggan dengan otomatisasi transkrip dan analisis. Hal ini dapat memahami kebutuhan pelanggan untuk memberikan solusi yang lebih relevan dan meningkatkan peluang kesuksesan penjualan.</p>',
    },
  ];
  return (
    <section className="bg-[#F6F5ED]">
      <div className="section-container !py-10 flex flex-col gap-5">
        <h2 className="text-lg lg:text-2xl font-[600]">Beragam Fitur Layanan Zoom</h2>

        <p className="text-sm text-justify">
          Dengan katalog layanan Zoom di Xooply, Anda bisa menikmati berbagai solusi untuk
          meningkatkan produktivitas kerja dan kolaborasi tim, semua tersedia untuk kebutuhan bisnis
          Anda. Di setiap katalog langganan Zoom, Anda{' '}
          <span className="font-bold">otomatis mendapatkan fitur AI Companion</span> yang dirancang
          khusus untuk meningkatkan kemudahan dan kenyamanan Anda.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {catalog.map((item, index) => (
            <div
              key={index}
              className="bg-white flex flex-col gap-2.5 shadow-[0_0_10px_0_rgba(0,0,0,0.1)] p-5 rounded-[20px]"
            >
              <div className="flex justify-between items-center">
                <h3 className="text-sm font-bold text-[#555555]">{item.label}</h3>

                <img alt={item.label} src={item.iconUrl} className="w-[35px]" />
              </div>

              <EmbeddedYoutube videoId={item.videoId} />

              <div
                dangerouslySetInnerHTML={{
                  __html: item.desc,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CatalogSection;
